import { requesURLResetPassword, updateNewPassword, validateUrlResetPassword }
  from '@/backend/recoverPassword'
import store from '@/store'
import i18n from '../../lang'
import { setAccessToken } from '@/backend/storage'
import { authenticate } from '@/backend/auth'

export const actions = {
  requestResetPassword({ commit, dispatch }, email) {
    return requesURLResetPassword(email).
    then( response => {
      var message = { type: 'success', content: response.data.message }
      dispatch('message/enable', message, { root: true })
    }).
    catch( error => {
      if(error.response && error.response.status == 400){
        var message = { type: 'info', content: error.response.data.message }
        dispatch('message/enable', message, { root: true })
      }
    })
  },

  async resetPassword({ commit, dispatch }, credentials) {
    try {
      await updateNewPassword(credentials);
      const authResponse = await authenticate(credentials.email, credentials.password)
      const access_token = authResponse.data.access_token
      dispatch('auth/signInAferResetPassword', access_token, { root: true })
      return { resetPasswordSuccess: true }
    }
    catch (error) {
      return { resetPasswordSuccess: false }
    }
  },

  validateUrl({ commit, dispatch}, params) {
    return validateUrlResetPassword(params)
    .then(response => {
      return { validURL: response.data }
    })
    .catch(error => {
      var message = { type: 'danger', content: error.response.data.error }
      dispatch('message/enable', message, { root: true })
      return { validURL: false }
    })
  }
}

export default {
  namespaced: true,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/recoverPassword.js